import { useEffect, useState } from "react";
import { selectCommunicationData } from "../../store";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { CommunicationType, FileItemType, FronteRetroFileItemType } from "../../types/communication/communicationDataType"
import { FileSideEnum, LinearFileTypeEnum } from "../../types/commonTypes";
import { saveCommunicationAct } from "../../store/communication-data/actions";
import FronteRetroFilesUploadListCmp from "./FronteRetroFilesUploadListCmp";
import { Vspace } from "../styled/Separators.style";
import { addFronteRetroNewEmptyItemIfNeeded, removeEmptyFronteRetroItems } from "../../utils/utils-files";

interface FronteRetroListProps {
    listObj: FronteRetroFileItemType[]
    arrayDbPropSync: string
    fileTypeFront: LinearFileTypeEnum
    fileTypeRear: LinearFileTypeEnum
    alreadySentDocIds?: string[]
}

/* istanbul ignore next */
export const FronteRetroList = (props: FronteRetroListProps) => {
    const dispatch = useAppDispatch();
    const communicationData = useAppSelector(selectCommunicationData)
    const { communication }: any = communicationData
    const { listObj, arrayDbPropSync, fileTypeFront, fileTypeRear, alreadySentDocIds } = props
    const [currList, setCurrList] = useState<FronteRetroFileItemType[]>(listObj || [])

    const updateDbCommunicationFileList = (newFileList: FileItemType[], fileSideEnum: FileSideEnum, arrayIndex: number) => {
        let newList = [...currList]
        newList[arrayIndex][fileSideEnum] = newFileList

        // Remove empty items
        newList = removeEmptyFronteRetroItems(newList)

        // Add new fronte-retro item if last item is being filled
        newList = addFronteRetroNewEmptyItemIfNeeded(newList)

        // Update current and db list
        setCurrList(newList)

        if (arrayDbPropSync) {
            const updComm: any = new CommunicationType(communication)

            if (updComm[arrayDbPropSync]) {
                updComm[arrayDbPropSync] = newList

                dispatch(saveCommunicationAct({
                    data: updComm
                })
                )
            }
        }
    }

    useEffect(() => {
        if (listObj?.length === 0) {
            setCurrList([new FronteRetroFileItemType()])
        }
    }, [listObj?.length])

    return (
        <>
            {currList.map((cl: FronteRetroFileItemType, arrayIndex: number) => <div
                key={arrayIndex}
            >
                <FronteRetroFilesUploadListCmp
                    key={arrayIndex}
                    customUpdateDbCommunicationFileList={(newFiles: FileItemType[], fileSideEnum: FileSideEnum) => updateDbCommunicationFileList(newFiles, fileSideEnum, arrayIndex)}
                    initFronteRetroObj={cl}
                    arrayDbPropSync={arrayDbPropSync}
                    fileTypeFront={fileTypeFront}
                    fileTypeRear={fileTypeRear}
                    alreadySentDocIds={alreadySentDocIds}
                    textLabelFront={"Aggiungi Fronte"}
                    textLabelRear={"Aggiungi Retro"}
                    adaptingDoubleLine={true}
                />
                <Vspace qty={1.5}></Vspace>
            </div>)}
        </>
    )
}

export default FronteRetroList